import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

/**
 * Rangos (franjas) de un horario. Los dos params son opcionales:
 *   - sin nada, trae todos;
 *   - con `horarioId`, los de esa jornada, que es como lo usa la pantalla.
 */
export const RNHHorarioRangoGet = async (credentials, data) => {
  const body = {
    service: "RNHHorarioRangoGet",
    params: {
      rnhHorarioRangoId: data?.id || null,
      rnhHorarioRangoHorarioId: data?.horarioId || null,
    },
  };
  return respuestaDe(await axiosPost(body, credentials));
};
